import { Pipe, PipeTransform } from '@angular/core';

import _ from 'lodash';

import { UserNotificationCategory } from '../models';

@Pipe({
	name: 'userNotificationCategoryFilter',
	standalone: false,
})
export class UserNotificationCategoryFilterPipe implements PipeTransform {
	transform(
		userNotificationCategories: UserNotificationCategory[],
		recipientType: 'broker' | 'customer' | 'lead' | 'enterprise',
		userNotificationCategoryTypeId: number,
		isMandatory?: boolean,
		isSubAgent?: boolean,
		isPaidIndividually?: boolean,
	): UserNotificationCategory[] {
		return _.orderBy(
			userNotificationCategories && userNotificationCategories.length && recipientType
				? userNotificationCategories.filter(
						u =>
							(recipientType !== 'broker' || u.isBrokerLevel) &&
							(recipientType !== 'customer' || u.isCustomerLevel) &&
							(recipientType !== 'lead' || u.isLeadLevel) &&
							(recipientType !== 'enterprise' || u.isEnterpriseLevel) &&
							(_.isNil(userNotificationCategoryTypeId) || userNotificationCategoryTypeId === u.userNotificationCategoryTypeId) &&
							(_.isNil(isMandatory) || isMandatory === u.isMandatory) &&
							(!isSubAgent || !u.isParentOnly || (u.isAffectedByIsPaidIndividually && isPaidIndividually)),
					)
				: userNotificationCategories,
			e => e.sortOrder,
		);
	}
}
